import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const OfferActivation = ({
  offer,
  isAttrLoaded,
  client,
  activated,
  singleOfferActivated,
  remainingTime,
  isUnderGap,
  activateOffer,
  tenanturl,
  language,
  tenant,
  isUnlimitedReactivation,
  unlimitedOfferActivated,
  isFinalActivation,
}) => {
  useEffect(() => {
    if (isFinalActivation) {
      // console.log("Final Activation of offer id: ", offer.id);
    }
  }, [isFinalActivation, offer]);
  //   useEffect(() => {
  //     // console.log(
  //     //   `Offer: ${offer.id} activated`,
  //     //   activated,
  //     //   "isUnderGap",
  //     //   isUnderGap
  //     // );
  //     if (isUnlimitedReactivation) {
  //       console.log(
  //         `Offer: ${offer.id} isUnderGap ? : ${isUnderGap} unlimitedOfferActivatedss`,
  //         unlimitedOfferActivated
  //       );
  //     }
  //     if (isUnlimitedReactivation && isUnderGap) {
  //       console.log("isUnderGap", isUnderGap);
  //       const interval = setInterval(() => {
  //         console.log("Interval");
  //         if (remainingTime) {
  //           remainingTime = remainingTime - 1;
  //         }
  //       }, 1000);
  //       return () => clearInterval(interval);
  //     }
  //   }, [isUnlimitedReactivation, offer, unlimitedOfferActivated]);

  // Helper function to determine which activation state to render
  const renderActivationState = () => {
    // Single activation cases

    if (activated && singleOfferActivated) {
      return (
        <div className="pe-3 ps-3">
          <div className="text-decoration-none w-100 d-block btn btn-primary rounded-5">
            {language?.static_labels.activated}
          </div>
        </div>
      );
    }
    /*
     * offer with unlimited reactivations
     * (remainingActivations = null and activationExpiry = null and activationStatus = "Not Activated" initally)
     * after activated (remainingActivations = null and activationExpiry = a proper timestamp ex: 2024-12-19T02:28:52.000Z and activationStatus = "Activated")
     * after activation expiry (remainingActivations = null and activationExpiry = a proper timestamp ex: 2024-12-19T02:28:52.000Z and activationStatus = "Expired")
     *
     */

    if (
      offer.remainingActivations === null &&
      offer.activationExpiry === null &&
      offer.activationStatus === "Not Activated"
    ) {
      return (
        <div className="pe-3 ps-3">
          <Button onClick={activateOffer} className="w-100 rounded-5">
            {language?.static_labels.click_to_activate}
          </Button>
        </div>
      );
    }

    // if (isUnlimitedReactivation && unlimitedOfferActivated) {
    //   return (
    //     <div className="pe-3 ps-3">
    //       <div className="text-decoration-none w-100 d-block btn btn-primary rounded-5">
    //         {language?.static_labels.activated}
    //       </div>
    //       {renderExpiryTimer()}
    //     </div>
    //   );
    // }

    if (
      offer.remainingActivations === null &&
      offer.activationExpiry &&
      offer.activationStatus === "Activated"
    ) {
      return (
        <div className="pe-3 ps-3">
          <div className="text-decoration-none w-100 d-block btn btn-primary rounded-5">
            {language?.static_labels.activated}
          </div>
          {renderExpiryTimer()}
        </div>
      );
    }

    // Offer with no remaining activations and expiry, already activated
    if (
      !offer.remainingActivations &&
      !offer.activationExpiry &&
      offer.activationStatus === "Activated"
    ) {
      return (
        <div className="pe-3 ps-3">
          <div className="text-decoration-none w-100 d-block btn btn-primary rounded-5">
            {language?.static_labels.activated}
          </div>
        </div>
      );
    }

    // Offer with no remaining activations and expiry, not activated
    if (
      !offer.remainingActivations &&
      !offer.activationExpiry &&
      offer.activationStatus === "Not Activated"
    ) {
      return (
        <div className="pe-3 ps-3">
          <Button onClick={activateOffer} className="w-100 rounded-5">
            {language?.static_labels.click_to_activate}
          </Button>
        </div>
      );
    }

    if (
      (activated &&
        offer.activationExpiry &&
        offer.remainingActivations === 0) ||
      (activated &&
        offer.activationExpiry &&
        offer.remainingActivations === 0 &&
        offer.activationStatus === "Activated")
    ) {
      return (
        <div className="pe-3 ps-3">
          <div className="text-decoration-none w-100 d-block btn btn-primary rounded-5">
            {language?.static_labels.activated}
          </div>
          {renderExpiryTimer()}
        </div>
      );
    }

    if (
      activated &&
      //   offer.activationExpiry &&
      //   offer.remainingActivations &&
      isUnlimitedReactivation
    ) {
      return (
        <div className="pe-3 ps-3">
          <div className="text-decoration-none w-100 d-block btn btn-primary rounded-5">
            {language?.static_labels.activated}
          </div>
          {renderExpiryTimer()}
        </div>
      );
    }

    // Activated offer with both expiry and remaining activations
    if (activated && offer.activationExpiry && offer.remainingActivations) {
      return (
        <div className="pe-3 ps-3">
          <div className="text-decoration-none w-100 d-block btn btn-primary rounded-5">
            {language?.static_labels.activated}
          </div>
          {renderExpiryTimer()}
        </div>
      );
    }

    // Activated offer with expiry but no remaining activations
    if (
      offer.activationExpiry &&
      offer.remainingActivations === null &&
      offer.activationStatus === "Activated"
    ) {
      return (
        <div className="pe-3 ps-3">
          <div className="text-decoration-none w-100 d-block btn btn-primary rounded-5">
            {language?.static_labels.activated}
          </div>
          {renderExpiryTimer()}
        </div>
      );
    }

    // Activated offer with remaining activations but no expiry
    if (!offer.activationExpiry && offer.remainingActivations && activated) {
      return (
        <div className="pe-3 ps-3">
          <div className="text-decoration-none w-100 d-block btn btn-primary rounded-5">
            {language?.static_labels.activated}
          </div>
          {renderExpiryTimer()}
        </div>
      );
    }

    // Not activated conditions
    if (!activated) {
      if (
        (!offer.remainingActivations &&
          !offer.activationExpiry &&
          offer.activationStatus === "Not Activated") ||
        (offer.remainingActivations &&
          !offer.activationExpiry &&
          offer.activationStatus === "Not Activated")
      ) {
        return (
          <div className="pe-3 ps-3">
            <Button onClick={activateOffer} className="w-100 rounded-5">
              {language?.static_labels.click_to_activate}
            </Button>
          </div>
        );
      }
      if (!activated && isUnlimitedReactivation) {
        return (
          <div className="pe-3 ps-3">
            <Button
              onClick={activateOffer}
              disabled={isUnderGap}
              className="w-100 rounded-5"
            >
              {language?.static_labels.click_to_activate}
            </Button>
            {isUnderGap && remainingTime && renderReactivationTimer()}
          </div>
        );
      }

      if (!offer.remainingActivations || offer.remainingActivations > 0) {
        return (
          <div className="pe-3 ps-3">
            <Button
              onClick={activateOffer}
              disabled={isUnderGap}
              className="w-100 rounded-5"
            >
              {language?.static_labels.click_to_activate}
            </Button>
            {isUnderGap && remainingTime && renderReactivationTimer()}
          </div>
        );
      }
    }

    return null;
  };

  // Helper component for expiry timer
  const renderExpiryTimer = () => (
    <div className="border border-primary me-0 ms-0 mt-2 rounded-5 row text-primary">
      <div
        className="col border-end border-primary"
        style={{ fontSize: "8px", lineHeight: "30px", whiteSpace: "nowrap" }}
      >
        {language?.static_labels.activation_expire_in}
      </div>
      <div
        className="col"
        style={{ fontSize: "12px", lineHeight: "30px", whiteSpace: "nowrap" }}
      >
        {remainingTime}
      </div>
    </div>
  );

  // Helper component for reactivation timer
  const renderReactivationTimer = () => (
    <div className="border border-primary me-0 ms-0 mt-2 rounded-5 row text-primary">
      <div
        className="col border-end border-primary"
        style={{ fontSize: "8px", lineHeight: "30px" }}
      >
        {language?.static_labels.reactivate_in}
      </div>
      <div className="col" style={{ fontSize: "12px", lineHeight: "30px" }}>
        {remainingTime}
      </div>
    </div>
  );

  if (!offer.activationRequired) {
    return tenant?.tenantmasterconfig?.time_bound.show_view ? (
      <div className="pe-3 ps-3">
        <Link
          className="btn btn-primary text-decoration-none w-100 d-block rounded-5"
          to={`/${tenanturl}/offerdetail/${offer.id}`}
        >
          {language?.static_labels.view_detail}
        </Link>
      </div>
    ) : null;
  }

  if (!isAttrLoaded) {
    return null;
  }

  if (!client) {
    return (
      <div className="pe-3 ps-3">
        <Link
          className="btn btn-secondary text-decoration-none w-100 d-block rounded-5"
          to={`/${tenanturl}/signin`}
        >
          {language?.static_labels.signin_to_activate}
        </Link>
      </div>
    );
  }

  return renderActivationState();
};

export default OfferActivation;
